import { Injectable } from '@angular/core';
import { Curso } from '../interfaces/curso.interface';


@Injectable({
  providedIn: 'root'
})
export class CursosService {

  cursos: Curso[] = [
    {
      nome: 'HTML e CSS: Classes, posicionamento e Flexbox',
      nomeEn: 'HTML and CSS: Classes, positioning and Flexbox',
      nomeEs: 'HTML y CSS: Clases, posicionamiento y Flexbox',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 1
    },
    {
      nome: 'HTML e CSS: cabeçalho, footer e variáveis CSS',
      nomeEn: 'HTML and CSS: header, footer and CSS variables',
      nomeEs: 'HTML y CSS: encabezado, pie de página y variables CSS',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 2
    },
    {
      nome: 'HTML e CSS: ambientes de desenvolvimento, estrutura de arquivos e tags',
      nomeEn: 'HTML and CSS: development environments, file structure and tags',
      nomeEs: 'HTML y CSS: entornos de desarrollo, estructura de archivos y etiquetas',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 3
    },
    {
      nome: 'HTML e CSS: trabalhando com responsividade e publicação de projetos',
      nomeEn: 'HTML and CSS: working with responsiveness and project deployment',
      nomeEs: 'HTML y CSS: trabajando con responsividad y publicación de proyectos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 4
    },
    {
      nome: 'HTML e CSS: praticando HTML/CSS',
      nomeEn: 'HTML and CSS: practicing HTML/CSS',
      nomeEs: 'HTML y CSS: practicando HTML/CSS',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 5
    },
    {
      nome: 'HTML e CSS: responsividade com mobile-first',
      nomeEn: 'HTML and CSS: mobile-first responsiveness',
      nomeEs: 'HTML y CSS: responsividad con mobile-first',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '02/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 6
    },
    {
      nome: 'CSS: Flexbox e layouts responsivos',
      nomeEn: 'CSS: Flexbox and responsive layouts',
      nomeEs: 'CSS: Flexbox y diseños responsivos',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '02/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 7
    },
    {
      nome: 'Git e GitHub: dominando controle de versão de código',
      nomeEn: 'Git and GitHub: mastering code version control',
      nomeEs: 'Git y GitHub: dominando el control de versiones de código',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '03/2024',
      tag: 'Git',
      tagEn: 'Git',
      tagEs: 'Git',
      id: 8
    },
    {
      nome: 'CSS: construindo layouts com Grid',
      nomeEn: 'CSS: building layouts with Grid',
      nomeEs: 'CSS: construyendo diseños con Grid',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '03/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 9
    },
    {
      nome: 'SASS e CSS: estilizando um site',
      nomeEn: 'SASS and CSS: styling a website',
      nomeEs: 'SASS y CSS: estilizando un sitio web',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '03/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 10
    },
    {
      nome: 'Tailwind CSS: estilizando a sua página com classes utilitárias',
      nomeEn: 'Tailwind CSS: styling your page with utility classes',
      nomeEs: 'Tailwind CSS: estilizando tu página con clases utilitarias',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '03/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 11
    },
    {
      nome: 'Praticando CSS: Grid e Flexbox',
      nomeEn: 'Practicing CSS: Grid and Flexbox',
      nomeEs: 'Practicando CSS: Grid y Flexbox',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '03/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 12
    },
    {
      nome: 'Lógica de programação: mergulhe em programação com JavaScript',
      nomeEn: 'Programming logic: dive into programming with JavaScript',
      nomeEs: 'Lógica de programación: sumérgete en la programación con JavaScript',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '04/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 13
    },
    {
      nome: 'Git e GitHub: compartilhando e colaborando em projetos',
      nomeEn: 'Git and GitHub: sharing and collaborating on projects',
      nomeEs: 'Git y GitHub: compartiendo y colaborando en proyectos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '04/2024',
      tag: 'Git',
      tagEn: 'Git',
      tagEs: 'Git',
      id: 14
    },
    {
      nome: 'Lógica de programação: explore funções e listas',
      nomeEn: 'Programming logic: explore functions and lists',
      nomeEs: 'Lógica de programación: explore funciones y listas',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '04/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 15
    },
    {
      nome: 'Lógica de programação: praticando com desafios',
      nomeEn: 'Programming logic: practicing with challenges',
      nomeEs: 'Lógica de programación: practicando con desafíos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 16
    },
    {
      nome: 'JavaScript para Web: Crie páginas dinâmicas',
      nomeEn: 'JavaScript for Web: Create dynamic pages',
      nomeEs: 'JavaScript para Web: Crea páginas dinámicas',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 17
    },
    {
      nome: 'JavaScript: manipulando elementos no DOM',
      nomeEn: 'JavaScript: manipulating elements in the DOM',
      nomeEs: 'JavaScript: manipulando elementos en el DOM',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 18
    },
    {
      nome: 'JavaScript: explorando a manipulação de elementos e da localStorage',
      nomeEn: 'JavaScript: exploring element and localStorage manipulation',
      nomeEs: 'JavaScript: explorando la manipulación de elementos y localStorage',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 19
    },
    {
      nome: 'JavaScript: validações e reconhecimento de voz',
      nomeEn: 'JavaScript: validations and voice recognition',
      nomeEs: 'JavaScript: validaciones y reconocimiento de voz',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 20
    },
    {
      nome: 'JavaScript: consumindo e tratando dados de uma API',
      nomeEn: 'JavaScript: consuming and handling data from an API',
      nomeEs: 'JavaScript: consumiendo y manejando datos de una API',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 21
    },
    {
      nome: 'JavaScript: métodos de array',
      nomeEn: 'JavaScript: array methods',
      nomeEs: 'JavaScript: métodos de array',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '05/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 22
    },
    {
      nome: 'SEO: Otimização de sites',
      nomeEn: 'SEO: Website optimization',
      nomeEs: 'SEO: Optimización de sitios web',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '05/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 23
    },
    {
      nome: 'JavaScript: criando requisições',
      nomeEn: 'JavaScript: creating requests',
      nomeEs: 'JavaScript: creando solicitudes',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '06/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 24
    },
    {
      nome: 'JavaScript: validando formulários',
      nomeEn: 'JavaScript: validating forms',
      nomeEs: 'JavaScript: validando formularios',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '06/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 25
    },
    {
      nome: 'JavaScript: trabalhando com threads para requisições simultâneas',
      nomeEn: 'JavaScript: working with threads for simultaneous requests',
      nomeEs: 'JavaScript: trabajando con hilos para solicitudes simultáneas',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '06/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 26
    },
    {
      nome: 'Acessibilidade web: crie designs inclusivos',
      nomeEn: 'Web accessibility: create inclusive designs',
      nomeEs: 'Accesibilidad web: crea diseños inclusivos',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '06/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 27
    },
    {
      nome: 'Acessibilidade web parte 1: tornando seu front-end inclusivo',
      nomeEn: 'Web accessibility part 1: making your front-end inclusive',
      nomeEs: 'Accesibilidad web parte 1: haciendo tu front-end inclusivo',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '06/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 28
    },
    {
      nome: 'Acessibilidade web parte 2: componentes acessíveis com um pouco de JavaScript',
      nomeEn: 'Web accessibility part 2: accessible components with a little JavaScript',
      nomeEs: 'Accesibilidad web parte 2: componentes accesibles con un poco de JavaScript',
      instituicao: 'Alura',
      duracao: '4',
      dataConclusao: '06/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 29
    },
    {
      nome: 'IA generativa no Front-end: trabalhando com acessibilidade, semântica e HTML',
      nomeEn: 'Generative AI in Front-end: working with accessibility, semantics and HTML',
      nomeEs: 'IA generativa en Front-end: trabajando con accesibilidad, semántica y HTML',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '06/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 30
    },
    {
      nome: 'TypeScript parte 1: evoluindo seu JavaScript',
      nomeEn: 'TypeScript part 1: evolving your JavaScript',
      nomeEs: 'TypeScript parte 1: evolucionando tu JavaScript',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 31
    },
    {
      nome: 'TypeScript parte 2: avançando na linguagem',
      nomeEn: 'TypeScript part 2: advancing in the language',
      nomeEs: 'TypeScript parte 2: avanzando en el lenguaje',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '07/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 32
    },
    {
      nome: 'TypeScript parte 3: Mais técnicas e boas práticas',
      nomeEn: 'TypeScript part 3: More techniques and best practices',
      nomeEs: 'TypeScript parte 3: Más técnicas y buenas prácticas',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '07/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 33
    },
    {
      nome: 'SEO: dominando estratégias e ferramentas para aumento de conversões',
      nomeEn: 'SEO: mastering strategies and tools for increasing conversions',
      nomeEs: 'SEO: dominando estrategias y herramientas para aumentar conversiones',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 34
    },
    {
      nome: 'Google Analytics 4: implementação e relatórios',
      nomeEn: 'Google Analytics 4: implementation and reporting',
      nomeEs: 'Google Analytics 4: implementación e reportes',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 35
    },
    {
      nome: 'SEO: plataformas CMS',
      nomeEn: 'SEO: CMS platforms',
      nomeEs: 'SEO: plataformas CMS',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 36
    },
    {
      nome: 'Acessibilidade no HTML: escrevendo códigos semânticos para inclusão',
      nomeEn: 'Accessibility in HTML: writing semantic code for inclusion',
      nomeEs: 'Accesibilidad en HTML: escribiendo código semántico para inclusión',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '07/2024',
      tag: 'HTML',
      tagEn: 'HTML',
      tagEs: 'HTML',
      id: 37
    },
    {
      nome: 'CSS: ajustando a acessibilidade visual em um projeto',
      nomeEn: 'CSS: adjusting visual accessibility in a project',
      nomeEs: 'CSS: ajustando la accesibilidad visual en un proyecto',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '07/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 38
    },
    {
      nome: 'Bootstrap5: crie uma landing page responsiva',
      nomeEn: 'Bootstrap5: create a responsive landing page',
      nomeEs: 'Bootstrap5: crea una landing page responsiva',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 39
    },
    {
      nome: 'Bootstrap 5: novos recursos e práticas recomendadas de HTML, CSS e JavaScript',
      nomeEn: 'Bootstrap 5: new features and best practices for HTML, CSS and JavaScript',
      nomeEs: 'Bootstrap 5: nuevas características y mejores prácticas para HTML, CSS y JavaScript',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 40
    },
    {
      nome: 'Linux Onboarding: usando a CLI de uma forma rápida e prática',
      nomeEn: 'Linux Onboarding: using the CLI in a fast and practical way',
      nomeEs: 'Linux Onboarding: usando la CLI de una forma rápida y práctica',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 41
    },
    {
      nome: 'WordPress: crie sites com Elementor e Figma',
      nomeEn: 'WordPress: create sites with Elementor and Figma',
      nomeEs: 'WordPress: crea sitios con Elementor y Figma',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 42
    },
    {
      nome: 'Wordpress: integrando responsividade, efeitos visuais e explorando plugins',
      nomeEn: 'Wordpress: integrating responsiveness, visual effects and exploring plugins',
      nomeEs: 'Wordpress: integrando responsividad, efectos visuales y explorando plugins',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 43
    },
    {
      nome: 'Terminal: aprenda comandos para executar tarefas',
      nomeEn: 'Terminal: learn commands to perform tasks',
      nomeEs: 'Terminal: aprenda comandos para realizar tareas',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 44
    },
    {
      nome: 'Terminal: manipule arquivos no terminal com comandos Linux',
      nomeEn: 'Terminal: manipulate files in the terminal with Linux commands',
      nomeEs: 'Terminal: manipule archivos en el terminal con comandos Linux',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 45
    },
    {
      nome: 'Wordpress: integrando responsividade, efeitos visuais e explorando plugins',
      nomeEn: 'Wordpress: integrating responsiveness, visual effects and exploring plugins',
      nomeEs: 'Wordpress: integrando responsividad, efectos visuales y explorando plugins',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 50
    },
    {
      nome: 'Terminal: aprenda comandos para executar tarefas',
      nomeEn: 'Terminal: learn commands to perform tasks',
      nomeEs: 'Terminal: aprenda comandos para realizar tareas',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 51
    },
    {
      nome: 'Windows Prompt: utilizando o CMD',
      nomeEn: 'Windows Prompt: using CMD',
      nomeEs: 'Windows Prompt: utilizando CMD',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 52
    },
    {
      nome: 'Expressões Regulares: faça buscas, validações e substituições de textos',
      nomeEn: 'Regular Expressions: perform search, validations and text replacements',
      nomeEs: 'Expresiones Regulares: realiza búsquedas, validaciones y sustituciones de textos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 53
    },
    {
      nome: 'Swagger: documentando suas APIs',
      nomeEn: 'Swagger: documenting your APIs',
      nomeEs: 'Swagger: documentando tus APIs',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 54
    },
    {
      nome: 'NGINX: servidor Web, Proxy Reverso e API Gateway',
      nomeEn: 'NGINX: Web server, Reverse Proxy and API Gateway',
      nomeEs: 'NGINX: servidor Web, Proxy Inverso y API Gateway',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 55
    },
    {
      nome: 'NGINX Parte 2: performance, FastCGI e HTTPS',
      nomeEn: 'NGINX Part 2: performance, FastCGI and HTTPS',
      nomeEs: 'NGINX Parte 2: performance, FastCGI y HTTPS',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 56
    },
    {
      nome: 'VSCode: aprendendo dicas e truques',
      nomeEn: 'VSCode: learning tips and tricks',
      nomeEs: 'VSCode: aprendiendo trucos y consejos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 57
    },
    {
      nome: 'ChatGPT e programação: aumente sua produtividade',
      nomeEn: 'ChatGPT and programming: increase your productivity',
      nomeEs: 'ChatGPT y programación: aumenta tu productividad',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 58
    },
    {
      nome: 'ChatGPT: otimizando a qualidade dos resultados',
      nomeEn: 'ChatGPT: optimizing result quality',
      nomeEs: 'ChatGPT: optimizando la calidad de los resultados',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 59
    },
    {
      nome: 'GitHub Copilot e ChatGPT: impulsionando seu desenvolvimento com IA',
      nomeEn: 'GitHub Copilot and ChatGPT: boosting your development with AI',
      nomeEs: 'GitHub Copilot y ChatGPT: impulsando tu desarrollo con IA',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 60
    },
    {
      nome: 'CSS: construindo layouts com Grid',
      nomeEn: 'CSS: building layouts with Grid',
      nomeEs: 'CSS: construyendo diseños con Grid',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '07/2024',
      tag: 'CSS',
      tagEn: 'CSS',
      tagEs: 'CSS',
      id: 61
    },
    {
      nome: 'Git e GitHub: repositório, commit e versões',
      nomeEn: 'Git and GitHub: repository, commit and versions',
      nomeEs: 'Git y GitHub: repositorio, commit y versiones',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Git',
      tagEn: 'Git',
      tagEs: 'Git',
      id: 62
    },
    {
      nome: 'Git e Github: controle e compartilhe seu código',
      nomeEn: 'Git and Github: control and share your code',
      nomeEs: 'Git y Github: controla y comparte tu código',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Git',
      tagEn: 'Git',
      tagEs: 'Git',
      id: 63
    },
    {
      nome: 'Git e Github: estratégias de ramificação, Conflitos e Pull Requests',
      nomeEn: 'Git and Github: branching strategies, Conflicts and Pull Requests',
      nomeEs: 'Git y Github: estrategias de ramificación, conflictos y Pull Requests',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '07/2024',
      tag: 'Git',
      tagEn: 'Git',
      tagEs: 'Git',
      id: 64
    },
    {
      nome: 'Vetores e Animação com SVG: trabalhando com CSS e JavaScript',
      nomeEn: 'Vectors and Animation with SVG: working with CSS and JavaScript',
      nomeEs: 'Vectores y Animación con SVG: trabajando con CSS y JavaScript',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '07/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 65
    },
    {
      nome: 'JavaScript: explorando a linguagem',
      nomeEn: 'JavaScript: exploring the language',
      nomeEs: 'JavaScript: explorando el lenguaje',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 66
    },
    {
      nome: 'JavaScript: programando a Orientação a Objetos',
      nomeEn: 'JavaScript: programming Object Orientation',
      nomeEs: 'JavaScript: programando la Orientación a Objetos',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 67
    },
    {
      nome: 'JavaScript: interfaces e Herança em Orientação a Objetos',
      nomeEn: 'JavaScript: interfaces and Inheritance in Object Orientation',
      nomeEs: 'JavaScript: interfaces y Herencia en Orientación a Objetos',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 68
    },
    {
      nome: 'JavaScript: de padrões a uma abordagem funcional',
      nomeEn: 'JavaScript: from patterns to a functional approach',
      nomeEs: 'JavaScript: de patrones a un enfoque funcional',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 69
    },
    {
      nome: 'JS na web: CRUD com JavaScript assíncrono',
      nomeEn: 'JS on the web: CRUD with asynchronous JavaScript',
      nomeEs: 'JS en la web: CRUD con JavaScript asincrónico',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 70
    },
    {
      nome: 'JavaScript: programação Orientada a Objetos',
      nomeEn: 'JavaScript: Object Oriented Programming',
      nomeEs: 'JavaScript: programación Orientada a Objetos',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 71
    },
    {
      nome: 'Node.js e terminal: dominando o ambiente de desenvolvimento front-end',
      nomeEn: 'Node.js and terminal: mastering the front-end development environment',
      nomeEs: 'Node.js y terminal: dominando el entorno de desarrollo front-end',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 72
    },
    {
      nome: 'Microsserviços: padrões de projeto',
      nomeEn: 'Microservices: design patterns',
      nomeEs: 'Microservicios: patrones de diseño',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 73
    },
    {
      nome: 'TypeScript na prática: implemente um projeto completo com TypeScript e módulos',
      nomeEn: 'TypeScript in practice: implement a complete project with TypeScript and modules',
      nomeEs: 'TypeScript en la práctica: implementa un proyecto completo con TypeScript y módulos',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '08/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 74
    },
    {
      nome: 'TypeScript: aplicando orientação a objetos no Front-end',
      nomeEn: 'TypeScript: applying object-oriented programming in front-end',
      nomeEs: 'TypeScript: aplicando programación orientada a objetos en front-end',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '08/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 75
    },
    {
      nome: 'TypeScript: o paradigma funcional no front-end',
      nomeEn: 'TypeScript: the functional paradigm in front-end',
      nomeEs: 'TypeScript: el paradigma funcional en front-end',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '08/2024',
      tag: 'TypeScript',
      tagEn: 'TypeScript',
      tagEs: 'TypeScript',
      id: 76
    },
    {
      nome: 'Angular 14: aplique os conceitos e desenvolva seu primeiro CRUD',
      nomeEn: 'Angular 14: apply the concepts and develop your first CRUD',
      nomeEs: 'Angular 14: aplica los conceptos y desarrolla tu primer CRUD',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 77
    },
    {
      nome: 'Angular 14: evoluindo a aplicação',
      nomeEn: 'Angular 14: evolving the application',
      nomeEs: 'Angular 14: evolucionando la aplicación',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 78
    },
    {
      nome: 'Angular: formulários orientados a templates',
      nomeEn: 'Angular: template-driven forms',
      nomeEs: 'Angular: formularios orientados a plantillas',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 79
    },
    {
      nome: 'RxJS e Angular: programando de forma reativa',
      nomeEn: 'RxJS and Angular: programming reactively',
      nomeEs: 'RxJS y Angular: programando de forma reactiva',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 80
    },
    {
      nome: 'Angular: torne sua aplicação interativa e personalizada com animações',
      nomeEn: 'Angular: make your application interactive and personalized with animations',
      nomeEs: 'Angular: haz tu aplicación interactiva y personalizada con animaciones',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 81
    },
    {
      nome: 'Angular: aprimore suas técnicas de animação e crie interfaces ainda mais atraentes',
      nomeEn: 'Angular: improve your animation techniques, create even more attractive interfaces',
      nomeEs: 'Angular: mejora tus técnicas de animación y crea interfaces aún más atractivas',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '08/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 82
    },
    {
      nome: 'Angular: componentização e design com Angular Material',
      nomeEn: 'Angular: componentization and design with Angular Material',
      nomeEs: 'Angular: componentización y diseño con Angular Material',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 83
    },
    {
      nome: 'Angular: componentização, formulários e interação com APIs',
      nomeEn: 'Angular: componentization, forms and interaction with APIs',
      nomeEs: 'Angular: componentización, formularios e interacción con APIs',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 84
    },
    {
      nome: 'Angular: trabalhando com Tokens JWT na autenticação e cadastro',
      nomeEn: 'Angular: working with JWT Tokens in authentication and registration',
      nomeEs: 'Angular: trabajando con Tokens JWT en autenticación y registro',
      instituicao: 'Alura',
      duracao: '12',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 85
    },
    {
      nome: 'Angular: testes automatizados com Jasmine e Karma',
      nomeEn: 'Angular: automated tests with Jasmine and Karma',
      nomeEs: 'Angular: pruebas automatizadas con Jasmine y Karma',
      instituicao: 'Alura',
      duracao: '14',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 86
    },
    {
      nome: 'Angular: avançando com testes automatizados',
      nomeEn: 'Angular: advancing with automated tests',
      nomeEs: 'Angular: avanzando con pruebas automatizadas',
      instituicao: 'Alura',
      duracao: '14',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 87
    },
    {
      nome: 'Angular: design de componentes com acessibilidade',
      nomeEn: 'Angular: component design with accessibility',
      nomeEs: 'Angular: diseño de componentes con accesibilidad',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 88
    },
    {
      nome: 'Angular: avançando no design de componentes com acessibilidade',
      nomeEn: 'Angular: advancing in component design with accessibility',
      nomeEs: 'Angular: avanzando en el diseño de componentes con accesibilidad',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 89
    },
    {
      nome: 'Angular: buscando, filtrando e exibindo dados de uma API',
      nomeEn: 'Angular: searching, filtering and displaying data from an API',
      nomeEs: 'Angular: buscando, filtrando y mostrando datos de una API',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 90
    },
    {
      nome: 'Angular: boas práticas de desenvolvimento: Modularização, Lazy Loading e Interceptors',
      nomeEn: 'Angular: development best practices: Modularization, Lazy Loading and Interceptors',
      nomeEs: 'Angular: buenas prácticas de desarrollo: Modularización, Lazy Loading e Interceptors',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 91
    },
    {
      nome: 'Acessibilidade no Angular: aprimorando formulários, modais e rotas',
      nomeEn: 'Accessibility in Angular: Enhancing forms, modals and routes',
      nomeEs: 'Accesibilidad en Angular: Mejorando formularios, modales y rutas',
      instituicao: 'Alura',
      duracao: '6',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 92
    },
    {
      nome: 'Angular: construa uma aplicação web: componentes, linguagem de template e CLI',
      nomeEn: 'Angular: build a web application: components, template language and CLI',
      nomeEs: 'Angular: construye una aplicación web: componentes, lenguaje de plantillas y CLI',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 93
    },
    {
      nome: 'JavaScript: manipulando objetos',
      nomeEn: 'JavaScript: manipulating objects',
      nomeEs: 'JavaScript: manipulando objetos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 94
    },
    {
      nome: 'Angular: ciclo de vida',
      nomeEn: 'Angular: life cycle',
      nomeEs: 'Angular: ciclo de vida',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 95
    },
    {
      nome: 'Angular: evoluindo com formulários e roteamento',
      nomeEn: 'Angular: evolving with forms and routing',
      nomeEs: 'Angular: evolucionando con formularios y enrutamiento',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 96
    },
    {
      nome: 'HTTP: entendendo a web por baixo dos panos',
      nomeEn: 'HTTP: understanding the web under the hood',
      nomeEs: 'HTTP: entendiendo la web bajo el capó',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '09/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 97
    },
    {
      nome: 'Angular: comunicando-se com uma API via requisições HTTP',
      nomeEn: 'Angular: communicating with an API via HTTP requests',
      nomeEs: 'Angular: comunicándose con una API a través de solicitudes HTTP',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 98
    },
    {
      nome: 'Padrões de API: do HTTP à modelagem de APIs',
      nomeEn: 'API Patterns: from HTTP to API modeling',
      nomeEs: 'Patrones de API: de HTTP a la modelización de APIs',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 99
    },
    {
      nome: 'WordPress: passo a passo para criar seu primeiro blog',
      nomeEn: 'WordPress: step by step to create your first blog',
      nomeEs: 'WordPress: paso a paso para crear tu primer blog',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 100
    },
    {
      nome: 'JavaScript: implementando CRUD com requisições HTTP',
      nomeEn: 'JavaScript: implementing CRUD with HTTP requests',
      nomeEs: 'JavaScript: implementando CRUD con solicitudes HTTP',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 101
    },
    {
      nome: 'Angular: implemente testes de unidade com Jest',
      nomeEn: 'Angular: implement unit tests with Jest',
      nomeEs: 'Angular: implementa pruebas unitarias con Jest',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 102
    },
    {
      nome: 'Angular: expandindo funcionalidades com testes unitários e e2e',
      nomeEn: 'Angular: expanding features with unit and e2e tests',
      nomeEs: 'Angular: expandiendo funcionalidades con pruebas unitarias y e2e',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 103
    },
    {
      nome: 'Angular: explorando testes de unidade e integração',
      nomeEn: 'Angular: exploring unit and integration tests',
      nomeEs: 'Angular: explorando pruebas unitarias e integración',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 104
    },
    {
      nome: 'Angular: escreva testes end-to-end com Playwright',
      nomeEn: 'Angular: write end-to-end tests with Playwright',
      nomeEs: 'Angular: escribe pruebas end-to-end con Playwright',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '09/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 105
    },
    {
      nome: 'Design: entenda e conheça a área',
      nomeEn: 'Design: understand and know the field',
      nomeEs: 'Diseño: entiende y conoce el área',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 106
    },
    {
      nome: 'Angular: teste e otimize o fluxo de autenticação com Playwright',
      nomeEn: 'Angular: test and optimize the authentication flow with Playwright',
      nomeEs: 'Angular: prueba y optimiza el flujo de autenticación con Playwright',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 107
    },
    {
      nome: 'Vue 3: entendendo componentes, diretivas e reatividade no framework',
      nomeEn: 'Vue 3: understanding components, directives and reactivity in the framework',
      nomeEs: 'Vue 3: entendiendo componentes, directivas y reactividad en el framework',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '10/2024',
      tag: 'Vue',
      tagEn: 'Vue',
      tagEs: 'Vue',
      id: 108
    },
    {
      nome: 'Vue3: avançando no framework',
      nomeEn: 'Vue3: advancing in the framework',
      nomeEs: 'Vue3: avanzando en el framework',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'Vue',
      tagEn: 'Vue',
      tagEs: 'Vue',
      id: 109
    },
    {
      nome: 'Vue3: explorando o framework',
      nomeEn: 'Vue3: exploring the framework',
      nomeEs: 'Vue3: explorando el framework',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'Vue',
      tagEn: 'Vue',
      tagEs: 'Vue',
      id: 110
    },
    {
      nome: 'Vue3: composition API e Vuex',
      nomeEn: 'Vue3: composition API and Vuex',
      nomeEs: 'Vue3: composition API y Vuex',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'Vue',
      tagEn: 'Vue',
      tagEs: 'Vue',
      id: 111
    },
    {
      nome: 'JavaScript: classes e heranças no desenv. de aplicações: orientação a objetos',
      nomeEn: 'JavaScript: classes and inheritance, develop. of applications: object orientation',
      nomeEs: 'JavaScript: clases y herencias, des. de aplicaciones con orientación a objetos',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '10/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 112
    },
    {
      nome: 'Cores no design: teoria e prática',
      nomeEn: 'Colors in design: theory and practice',
      nomeEs: 'Colores en diseño: teoría y práctica',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '11/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 113
    },
    {
      nome: 'Tipografia: conceitos e prática',
      nomeEn: 'Typography: concepts and practice',
      nomeEs: 'Tipografía: conceptos y práctica',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '11/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 114
    },
    {
      nome: 'Grids: como organizar o conteúdo visual',
      nomeEn: 'Grids: how to organize visual content',
      nomeEs: 'Grids: cómo organizar el contenido visual',
      instituicao: 'Alura',
      duracao: '10',
      dataConclusao: '11/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 115
    },
    {
      nome: 'Desenvolvimento Web Completo',
      nomeEn: 'Full Web Development',
      nomeEs: 'Desarrollo Web Completo',
      instituicao: 'Udemy',
      duracao: '118',
      dataConclusao: '8/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 116
    },
    {
      nome: 'Imersão Front-End',
      nomeEn: 'Front-End Immersion',
      nomeEs: 'Inmersión Front-End',
      instituicao: 'Alura',
      duracao: '5',
      dataConclusao: '2/2024',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 117
    },
    {
      nome: 'Angular Completo',
      nomeEn: 'Complete Angular',
      nomeEs: 'Angular Completo',
      instituicao: 'Loiane Groner',
      duracao: '100',
      dataConclusao: '10/2024',
      tag: 'Angular',
      tagEn: 'Angular',
      tagEs: 'Angular',
      id: 118
    },
    {
      nome: 'Lógica de Programação e Algoritmos com C#',
      nomeEn: 'Programming Logic and Algorithms with C#',
      nomeEs: 'Lógica de Programación y Algoritmos con C#',
      instituicao: 'Udemy',
      duracao: '17',
      dataConclusao: '9/2023',
      tag: 'Outros',
      tagEn: 'Others',
      tagEs: 'Otros',
      id: 119
    },
    {
      nome: 'Javascript do Zero',
      nomeEn: 'Javascript from Scratch',
      nomeEs: 'Javascript desde Cero',
      instituicao: 'Trybe',
      duracao: '10',
      dataConclusao: '1/2024',
      tag: 'JavaScript',
      tagEn: 'JavaScript',
      tagEs: 'JavaScript',
      id: 120
    },
    {
      nome: 'Design Visual: estratégias para planejar e construir seu portfólio',
      nomeEn: 'Visual Design: Strategies for Planning and Building Your Portfolio',
      nomeEs: 'Diseño Visual: Estrategias para Planificar y Construir tu Portafolio',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '12/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 121
    },
    {
      nome: 'UX Design: entenda a área da User Experience',
      nomeEn: 'UX Design: Understanding the User Experience Field',
      nomeEs: 'Diseño UX: Comprender el Área de la Experiencia del Usuario',
      instituicao: 'Alura',
      duracao: '8',
      dataConclusao: '12/2024',
      tag: 'UX & UI',
      tagEn: 'UX & UI',
      tagEs: 'UX & UI',
      id: 122
    },
    {
      nome: "UX Design: como construir uma persona",
      nomeEn: "UX Design: How to Build a Persona",
      nomeEs: "Diseño UX: Cómo Construir una Persona",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 123
    },
    {
      nome: "UX Design: elaborando projetos estratégicos",
      nomeEn: "UX Design: Developing Strategic Projects",
      nomeEs: "Diseño UX: Elaborar Proyectos Estratégicos",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 124
    },
    {
      nome: "UX Design: concepção do produto pós-pesquisa",
      nomeEn: "UX Design: Post-Research Product Conception",
      nomeEs: "Diseño UX: Concepción del Producto Después de la Investigación",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 125
    },
    {
      nome: "UX Design: criando um portfólio em UX",
      nomeEn: "UX Design: Creating a UX Portfolio",
      nomeEs: "Diseño UX: Creación de un Portafolio de UX",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 126
    },
    {
      nome: "Design Visual: aplicando técnicas de composição",
      nomeEn: "Visual Design: Applying Composition Techniques",
      nomeEs: "Diseño Visual: Aplicación de Técnicas de Composición",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 127
    },
    {
      nome: "Arquitetura da Informação: criando a experiência de navegação de um ambiente digital",
      nomeEn: "Information Architecture: Creating the Navigation Experience for a Digital Environment",
      nomeEs: "Arquitectura de la Información: Creación de la Experiencia de Navegación en un Entorno Digital",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 128
    },
    {
      nome: "Arquitetura da Informação: projetando para dispositivos móveis e e-commerces",
      nomeEn: "Information Architecture: Designing for Mobile Devices and E-Commerce",
      nomeEs: "Arquitectura de la Información: Diseño para Dispositivos Móviles y E-Commerce",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 129
    },
    {
      nome: "Arquitetura da Informação: estratégias e acompanhamento do produto",
      nomeEn: "Information Architecture: Strategies and Product Tracking",
      nomeEs: "Arquitectura de la Información: Estrategias y Seguimiento del Producto",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 130
    },
    {
      nome: "Arquitetura da Informação: técnicas de pesquisa para projetar experiências digitais",
      nomeEn: "Information Architecture: Research Techniques for Designing Digital Experiences",
      nomeEs: "Arquitectura de la Información: Técnicas de Investigación para Diseñar Experiencias Digitales",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 131
    },
    {
      nome: "Design System: projetando e construindo componentes",
      nomeEn: "Design System: Designing and Building Components",
      nomeEs: "Sistema de Diseño: Diseñar y Construir Componentes",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 132
    },
    {
      nome: "Design System: definindo estilos e tokens",
      nomeEn: "Design System: Defining Styles and Tokens",
      nomeEs: "Sistema de Diseño: Definir Estilos y Tokens",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 133
    },
    {
      nome: "Design System: documentando um design system",
      nomeEn: "Design System: Documenting a Design System",
      nomeEs: "Sistema de Diseño: Documentar un Sistema de Diseño",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 134
    },
    {
      nome: "UI para Devs: construa interfaces atraentes com fundamentos do design",
      nomeEn: "UI for Devs: Building Attractive Interfaces with Design Fundamentals",
      nomeEs: "UI para Devs: Construcción de Interfaces Atractivas con Fundamentos de Diseño",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 135
    },
    {
      nome: "UI para Devs: aprimorando projetos web com heurísticas",
      nomeEn: "UI for Devs: Enhancing Web Projects with Heuristics",
      nomeEs: "UI para Devs: Mejora de Proyectos Web con Heurísticas",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 136
    },
    {
      nome: "UI para devs: construindo interfaces animadas",
      nomeEn: "UI for Devs: Building Animated Interfaces",
      nomeEs: "UI para Devs: Construcción de Interfaces Animadas",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 137
    },
    {
      nome: "UX Research: metodologias e imersão em pesquisa",
      nomeEn: "UX Research: Methodologies and Immersion in Research",
      nomeEs: "Investigación UX: Metodologías e Inmersión en la Investigación",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 138
    },
    {
      nome: "Design Thinking: viabilizando soluções",
      nomeEn: "Design Thinking: Enabling Solutions",
      nomeEs: "Design Thinking: Hacer Viables las Soluciones",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 139
    },
    {
      nome: "UX Research: entrevistando pessoas usuárias",
      nomeEn: "UX Research: Interviewing Users",
      nomeEs: "Investigación UX: Entrevistando Usuarios",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 140
    },
    {
      nome: "UX Research: mapeando a experiência da pessoa usuária",
      nomeEn: "UX Research: Mapping the User Experience",
      nomeEs: "Investigación UX: Mapeando la Experiencia del Usuario",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 141
    },
    {
      nome: "UX Research: imersão em artefatos de pesquisas quantitativas",
      nomeEn: "UX Research: Immersion in Quantitative Research Artifacts",
      nomeEs: "Investigación UX: Inmersión en Artefactos de Investigación Cuantitativa",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 142
    },
    {
      nome: "UX Research: trazendo a acessibilidade para projetos digitais",
      nomeEn: "UX Research: Bringing Accessibility to Digital Projects",
      nomeEs: "Investigación UX: Trayendo Accesibilidad a Proyectos Digitales",
      instituicao: "Alura",
      duracao: "12",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 143
    },
    {
      nome: "UX Research: avaliando interfaces com heurísticas",
      nomeEn: "UX Research: Evaluating Interfaces with Heuristics",
      nomeEs: "Investigación UX: Evaluando Interfaces con Heurísticas",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 144
    },
    {
      nome: "UX Research: construindo o Benchmarking estratégico",
      nomeEn: "UX Research: Building Strategic Benchmarking",
      nomeEs: "Investigación UX: Construyendo el Benchmarking Estratégico",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 145
    },
    {
      nome: "UI Design: teste de usabilidade",
      nomeEn: "UI Design: Usability Testing",
      nomeEs: "Diseño UI: Pruebas de Usabilidad",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 146
    },
    {
      nome: "UX Strategy: visão estratégica do negócio",
      nomeEn: "UX Strategy: Strategic Business Vision",
      nomeEs: "Estrategia UX: Visión Estratégica del Negocio",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 147
    },
    {
      nome: "UX Strategy: conhecendo o perfil da pessoa usuária",
      nomeEn: "UX Strategy: Understanding the User Profile",
      nomeEs: "Estrategia UX: Conociendo el Perfil del Usuario",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 148
    },
    {
      nome: "UX Strategy: criando a modelagem de negócios",
      nomeEn: "UX Strategy: Creating Business Modeling",
      nomeEs: "Estrategia UX: Creando el Modelado de Negocios",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 149
    },
    {
      nome: "UX Strategy: conhecendo o mercado e testando ideias",
      nomeEn: "UX Strategy: Understanding the Market and Testing Ideas",
      nomeEs: "Estrategia UX: Conociendo el Mercado y Probando Ideas",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 150
    },
    {
      nome: "UX Strategy: análise de dados em um MVP",
      nomeEn: "UX Strategy: Data Analysis in an MVP",
      nomeEs: "Estrategia UX: Análisis de Datos en un MVP",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 151
    },
    {
      nome: "UX Strategy: analisando dados com analytics",
      nomeEn: "UX Strategy: Analyzing Data with Analytics",
      nomeEs: "Estrategia UX: Analizando Datos con Analytics",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 152
    },
    {
      nome: "UX Writing: escrevendo textos para usuários",
      nomeEn: "UX Writing: Writing for Users",
      nomeEs: "UX Writing: Escribiendo Textos para Usuarios",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 153
    },
    {
      nome: "UX Writing: pesquisa e testagem em UX Writing",
      nomeEn: "UX Writing: Research and Testing in UX Writing",
      nomeEs: "UX Writing: Investigación y Pruebas en UX Writing",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 154
    },
    {
      nome: "UX Writing: definindo o tom e voz da sua marca",
      nomeEn: "UX Writing: Defining Your Brand’s Tone and Voice",
      nomeEs: "UX Writing: Definiendo el Tono y Voz de Tu Marca",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 155
    },
    {
      nome: "UX Writing: arquitetura da Informação em Writing",
      nomeEn: "UX Writing: Information Architecture in Writing",
      nomeEs: "UX Writing: Arquitectura de la Información en Writing",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 156
    },
    {
      nome: "UX Writing: redação para experiências digitais",
      nomeEn: "UX Writing: Writing for Digital Experiences",
      nomeEs: "UX Writing: Redacción para Experiencias Digitales",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 157
    },
    {
      nome: "UX Writing: projetando um chatbot",
      nomeEn: "UX Writing: Designing a Chatbot",
      nomeEs: "UX Writing: Diseñando un Chatbot",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 158
    },
    {
      nome: "Figma: conhecendo a ferramenta",
      nomeEn: "Figma: Getting to Know the Tool",
      nomeEs: "Figma: Conociendo la Herramienta",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 159
    },
    {
      nome: "Figma: criando e evoluindo componentes de uma interface",
      nomeEn: "Figma: Creating and Evolving Interface Components",
      nomeEs: "Figma: Creando y Evolucionando Componentes de una Interfaz",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 160
    },
    {
      nome: "Figma: prototipagem interativa e animações",
      nomeEn: "Figma: Interactive Prototyping and Animations",
      nomeEs: "Figma: Prototipado Interactivo y Animaciones",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 161
    },
    {
      nome: "Inkscape: desenvolvendo uma identidade visual",
      nomeEn: "Inkscape: Developing a Visual Identity",
      nomeEs: "Inkscape: Desarrollando una Identidad Visual",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 162
    },
    {
      nome: "Inkscape: vetorizando com a ferramenta Bezier e criando simulações",
      nomeEn: "Inkscape: Vectorizing with the Bezier Tool and Creating Simulations",
      nomeEs: "Inkscape: Vectorizando con la Herramienta Bezier y Creando Simulaciones",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 163
    },
    {
      nome: "Inkscape: produzindo imagens para mídias sociais",
      nomeEn: "Inkscape: Producing Images for Social Media",
      nomeEs: "Inkscape: Produciendo Imágenes para Medios Sociales",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 164
    },
    {
      nome: "Inkscape: produção gráfica",
      nomeEn: "Inkscape: Graphic Production",
      nomeEs: "Inkscape: Producción Gráfica",
      instituicao: "Alura",
      duracao: "12",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 165
    },
    {
      nome: "Inkscape: construindo gráficos e objetos 3D",
      nomeEn: "Inkscape: Building Graphics and 3D Objects",
      nomeEs: "Inkscape: Construcción de Gráficos y Objetos 3D",
      instituicao: "Alura",
      duracao: "12",
      dataConclusao: "12/2024",
      tag: "UX & UI",
      tagEn: "UX & UI",
      tagEs: "UX & UI",
      id: 166
    },
    {
      nome: "Scrum: agilidade em seu projeto",
      nomeEn: "Scrum: Agility in Your Project",
      nomeEs: "Scrum: Agilidad en tu Proyecto",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "12/2024",
      tag: "Outros",
      tagEn: "Others",
      tagEs: "Otros",
      id: 167
    },
    {
      nome: "React: otimizando a performance",
      nomeEn: "React: Optimizing Performance",
      nomeEs: "React: Optimizando el Rendimiento",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 168
    },
    {
      nome: "React: gerenciando estado com Recoil",
      nomeEn: "React: Managing State with Recoil",
      nomeEs: "React: Gestión del Estado con Recoil",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 169
    },
    {
      nome: "React: escreva testes end to end com Cypress",
      nomeEn: "React: Writing End-to-End Tests with Cypress",
      nomeEs: "React: Escribiendo Pruebas End-to-End con Cypress",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 170
    },
    {
      nome: "React: avançando em testes e2e com Cypress",
      nomeEn: "React: Advancing in E2E Tests with Cypress",
      nomeEs: "React: Avanzando en Pruebas E2E con Cypress",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 171
    },
    {
      nome: "React: estilize componentes com Styled Components e manipule arquivos estáticos",
      nomeEn: "React: Styling Components with Styled Components and Handling Static Files",
      nomeEs: "React: Estilizando Componentes con Styled Components y Manejo de Archivos Estáticos",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 172
    },
    {
      nome: "React: desenvolvendo em React Router com JavaScript",
      nomeEn: "React: Developing with React Router and JavaScript",
      nomeEs: "React: Desarrollando con React Router y JavaScript",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 173
    },
    {
      nome: "React: Mutabilidade x Imutabilidade no Redux Toolkit com Immer",
      nomeEn: "React: Mutability vs. Immutability in Redux Toolkit with Immer",
      nomeEs: "React: Mutabilidad vs. Inmutabilidad en Redux Toolkit con Immer",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 174
    },
    {
      nome: "React: gerenciamento de estados globais com Redux",
      nomeEn: "React: Managing Global State with Redux",
      nomeEs: "React: Gestión del Estado Global con Redux",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 175
    },
    {
      nome: "React: gerencie estados globalmente com Context API",
      nomeEn: "React: Managing State Globally with Context API",
      nomeEs: "React: Gestión de Estado Globalmente con Context API",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 176
    },
    {
      nome: "React: gerenciamento de estados globais com ContextAPI",
      nomeEn: "React: Managing Global State with Context API",
      nomeEs: "React: Gestión del Estado Global con Context API",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 177
    },
    {
      nome: "React: escrevendo com Typescript",
      nomeEn: "React: Writing with TypeScript",
      nomeEs: "React: Escribiendo con TypeScript",
      instituicao: "Alura",
      duracao: "12",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 178
    },
    {
      nome: "React: entendendo Middlewares com Redux Thunk",
      nomeEn: "React: Understanding Middleware with Redux Thunk",
      nomeEs: "React: Comprendiendo Middleware con Redux Thunk",
      instituicao: "Alura",
      duracao: "6",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 179
    },
    {
      nome: "React: gerencie e valide formulários com o React Hook Form",
      nomeEn: "React: Managing and Validating Forms with React Hook Form",
      nomeEs: "React: Gestión y Validación de Formularios con React Hook Form",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 180
    },
    {
      nome: "React: autenticando usuários",
      nomeEn: "React: Authenticating Users",
      nomeEs: "React: Autenticando Usuarios",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 181
    },
    {
      nome: "React com TailwindCSS: estilizando componentes",
      nomeEn: "React with TailwindCSS: Styling Components",
      nomeEs: "React con TailwindCSS: Estilizando Componentes",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 182
    },
    {
      nome: "React JS: crie testes com Jest e Testing Library e garanta o funcionamento do Front-end",
      nomeEn: "React JS: Writing Tests with Jest and Testing Library to Ensure Front-end Functionality",
      nomeEs: "React JS: Escribiendo Pruebas con Jest y Testing Library para Garantizar la Funcionalidad del Front-end",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 183
    },
    {
      nome: "React: testando os seus componentes",
      nomeEn: "React: Testing Your Components",
      nomeEs: "React: Probando Tus Componentes",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 184
    },
    {
      nome: "React: conhecendo a biblioteca React Router",
      nomeEn: "React: Getting to Know the React Router Library",
      nomeEs: "React: Conociendo la Biblioteca React Router",
      instituicao: "Alura",
      duracao: "10",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 185
    },
    {
      nome: "React: integrando seu projeto React com APIs",
      nomeEn: "React: Integrating Your React Project with APIs",
      nomeEs: "React: Integrando Tu Proyecto React con APIs",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 186
    },
    {
      nome: "React: desenvolvendo com JavaScript",
      nomeEn: "React: Developing with JavaScript",
      nomeEs: "React: Desarrollando con JavaScript",
      instituicao: "Alura",
      duracao: "14",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 187
    },
    {
      nome: "React: praticando React com Js",
      nomeEn: "React: Practicing React with JS",
      nomeEs: "React: Practicando React con JS",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 188
    },
    {
      nome: "React: como os componentes funcionam",
      nomeEn: "React: How Components Work",
      nomeEs: "React: Cómo Funcionan los Componentes",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 189
    },
    {
      nome: "React: migrando para TypeScript",
      nomeEn: "React: Migrating to TypeScript",
      nomeEs: "React: Migrando a TypeScript",
      instituicao: "Alura",
      duracao: "8",
      dataConclusao: "01/2025",
      tag: "React",
      tagEn: "React",
      tagEs: "React",
      id: 190
    }
  ]

  constructor() {
  }

  getCursos(): Curso[] {
    try {
      if(!this.cursos) {
        throw new Error('Cursos não encontrados');
      }
      return this.cursos;
    } catch (error) {
      console.error('Erro ao buscar cursos', error);
      return [];
    }
  }
}
